export const showBrands = (state) => state.brands
